import { defineComponent as _defineComponent } from 'vue'
import { injectParentValidator } from '@/core/app.service';
import DeleteImageIcon from './DeleteImageIcon.vue';
import { computed, ref } from 'vue';
import dictionaryService from '@/core/dictionary.service';
import PdfUpload from './PdfUpload.vue';
import ImageUploadService from './image-upload.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageUpload',
  props: {
    chooseFileLabel: null,
    images: { default: () => [] }
  },
  emits: ['on-edit-images'],
  setup(__props: any, { emit }) {

const props = __props as { chooseFileLabel: string, images: CarouselImageWithExtension[] }



// New files to upload
const imageUploadFunction = ref<HTMLInputElement>(null);
// Files already uploaded
const imageUploadFiles = ref<HTMLInputElement>(null);


const previewImages = ref<CarouselImageWithExtension[]>([]);
const carouselImages = computed<CarouselImageWithExtension[]>(() => previewImages.value.filter(x => !ImageUploadService.isPdf(x)));
const imageZoomEnabled = ref<boolean>(false);

initLoadedPreviewImages();

injectParentValidator();

function initLoadedPreviewImages() {
    if (props.images) {
        for (let i = 0; i < props.images.length; i++) {
            previewImages.value.push(props.images[i]);
        }
    }
}

function clickImageUploadFunction() {
    (imageUploadFunction.value as any).click();
}

function addImages() {
    const transfer = new DataTransfer();
    const names = [];
    for (const file of imageUploadFiles.value.files) {
        transfer.items.add(file);
        names.push(file.name);
    }
    for (const file of imageUploadFunction.value.files) {
        if (names.indexOf(file.name) < 0) {
            transfer.items.add(file);
        }
    }

    imageUploadFiles.value.files = transfer.files;
    setMultiImagePreview();
}

function setMultiImagePreview() {
    // if (!props.images || !props.images.length) {
    //     previewImages.value = [];
    // }

    setPreviewImagesOnUpload();

    emit('on-edit-images', previewImages.value);
}

function setPreviewImagesOnUpload(): CarouselImage[] {
    const input = imageUploadFiles.value;
    const count = input.files.length;
    if (!input.files.length) {
        return;
    }
    for (let index = 0; index < count; index++) {
        const reader = new FileReader();
        const file = input.files[index];
        reader.onload = (e) => {
            if (previewImages.value.find(x => x.title === file.name)) {
                return;
            }
            previewImages.value.push(ImageUploadService.mapForUpload(file, e.target.result));
        };
        reader.readAsDataURL(file);
    }
    return previewImages.value;
}

function deleteImage(fileName: string) {
    const transfer = new DataTransfer();

    for (let i = 0; i < previewImages.value.length; i++) {
        if (previewImages.value[i].title === fileName) {
            previewImages.value.splice(i, 1);
        }
    }

    for (const file of imageUploadFiles.value.files) {
        if (file.name !== fileName) {
            transfer.items.add(file);
        }
    }

    imageUploadFiles.value.files = transfer.files;
    setMultiImagePreview();
    emit('on-edit-images', previewImages.value);
}

return { __sfc: true,props, imageUploadFunction, imageUploadFiles, emit, previewImages, carouselImages, imageZoomEnabled, initLoadedPreviewImages, clickImageUploadFunction, addImages, setMultiImagePreview, setPreviewImagesOnUpload, deleteImage, DeleteImageIcon, PdfUpload, ImageUploadService }
}

})